import { ApiResult, HttpClient } from "../http.js";
import {
  BidParticipantDto,
  PagedBidParticipants,
  ParticipantRole,
} from "../types/bid-participants.js";

export interface ListBidParticipantsQuery {
  page?: number;
  pageSize?: number;
  quoteId?: string;
  search?: string;
}

export interface CreateBidParticipantPayload {
  quoteId: string;
  userId: string;
  role: ParticipantRole;
  name: string;
  email: string;
  /** Optional permission overrides; the server defaults each from the role when omitted. */
  canUploadDocuments?: boolean;
  canSendMessages?: boolean;
  canLogTime?: boolean;
  id?: string;
}

export interface UpdateBidParticipantPayload {
  /** Omit to leave the role unchanged; when supplied the perms default to the role unless overridden. */
  role?: ParticipantRole;
  canUploadDocuments?: boolean;
  canSendMessages?: boolean;
  canLogTime?: boolean;
}

export class BidParticipantsApi {
  constructor(private readonly http: HttpClient) {}

  list(query: ListBidParticipantsQuery = {}): Promise<ApiResult<PagedBidParticipants>> {
    return this.http.get<PagedBidParticipants>("/api/bid-participants", { query: { ...query } });
  }

  get(id: string): Promise<ApiResult<BidParticipantDto>> {
    return this.http.get<BidParticipantDto>(`/api/bid-participants/${encodeURIComponent(id)}`);
  }

  create(payload: CreateBidParticipantPayload): Promise<ApiResult<string>> {
    return this.http.post<string>("/api/bid-participants", { body: payload });
  }

  update(id: string, payload: UpdateBidParticipantPayload): Promise<ApiResult<BidParticipantDto>> {
    return this.http.put<BidParticipantDto>(`/api/bid-participants/${encodeURIComponent(id)}`, { body: payload });
  }

  remove(id: string): Promise<ApiResult<boolean>> {
    return this.http.delete<boolean>(`/api/bid-participants/${encodeURIComponent(id)}`);
  }
}
